import React from 'react';

import { StyledGroup, StyledSegment } from './SegmentedControl.styles';
import { TSegmentedControlProps } from './SegmentedControl.types';

/**
 * Toggle-button group rather than a radio group: each segment stays independently
 * tabbable and reports its own state via `aria-pressed`. Radio semantics would promise
 * arrow-key traversal and a single tab stop, which this control does not implement.
 */
const SegmentedControl = ({
  value,
  onChange,
  options,
  label,
  className,
}: TSegmentedControlProps) => (
  <StyledGroup className={className} role="group" aria-label={label}>
    {options.map((option) => (
      <StyledSegment
        key={option.value}
        type="button"
        aria-label={option.ariaLabel}
        aria-pressed={option.value === value}
        isActive={option.value === value}
        onClick={() => onChange(option.value)}>
        {option.icon}
        {option.label}
      </StyledSegment>
    ))}
  </StyledGroup>
);

export default SegmentedControl;
